// extracted by mini-css-extract-plugin
module.exports = {"application-select":"styles-module__application-select___2LZLa"};